import * as React from 'react'
import { observer, inject } from 'mobx-react'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import { Button } from 'react-bootstrap'
import { history } from '../../../../Routing'
import Form, { ISubmitEvent } from 'react-jsonschema-form'

export interface IExternalDataSearchByBDayViewProps {
    localizationStore?: LocalizationStore,
    className?: string
}

@inject('localizationStore')
@observer
export default class ExternalDataSearchByBDayView
    extends React.Component<IExternalDataSearchByBDayViewProps> {

    constructor(props: any) {
        super(props)
    }

    schema: Object = {
        'type': 'object',
        'properties': {
            'bDay': {
                'title': this.props.localizationStore!.t('Enter bDay'),
                'type': 'string'
            }
        }
    }

    submit(e: ISubmitEvent<any>) {
        history.push('/externalData/searchByBDay/' + e.formData['bDay'])
    }

    render() {
        const self = this
        const { localizationStore } = this.props
        return (
            <div className="searchBlock">
                <Form
                    onSubmit={(e) => self.submit(e)}
                    schema={self.schema}
                >
                    <div className="searchBtn">
                        <Button type="submit">{localizationStore!.t!('SearchBtn')}</Button>
                    </div>
                </Form>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByBDayView.tsx